import React from 'react';
import './MainLayout.css';
import { Navbar } from '../components/Navbar';
import Footer from '../components/Footer';
import Seo from '../components/Seo';

function MainLayout({ children }) {
	return (
		<>
			<Seo />
			<Navbar></Navbar>

			<main className='page-content-wrapper'>{children}</main>
			<Footer></Footer>
		</>
	);
}

export default MainLayout;
